import React, { Component } from 'react';
import {
  Button, Form,
  FormGroup, Label,
  Input,
  Row, Col
} from 'reactstrap';
import { Redirect } from 'react-router-dom';

//components
import CustomSpinner from '../../components/CustomSpinner/CustomSpinner';

// modals
import AlertModal from '../../modal/AlertModal/AlertModal';
// import ErrorModal from '../../modal/ErrorModal/ErrorModal';

// services
import AuthService from '../../services/AuthService';
import Validation from '../../services/Validation';
import ModalService from '../../services/ModalService';
import Storage from '../../services/Storage';

class InvitedFleet extends Component {

  state = {
    height: window.innerHeight,
    width: window.innerWidth,
    redirectToLoginPage: false,
    isRequestSent: false,
    isLoading: false,
    controls: {
      mobile_number: {
        value: '',
        valid: null,
        touched: false,
        nullValue: null
      },
      otp: {
        value: '',
        valid: null,
        touched: false,
        nullValue: null
      }
    },
    isFormValid: false,
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeWindow);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeWindow);
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    if (!isNaN(e.target.value)) {
      controls[controlName].value = controlValue;
    }
    controls[controlName].touched = true;
    this.setState({ controls });
    this.handleValidation();
  }
  verifyOTP = () => {
    const { controls } = this.state;
    const { mobile_number, otp } = controls;
    const obj = {
      username: mobile_number.value,
      password: otp.value,
      grant_type: 'password',
      app: "baadshah"
    };
    this.setState({ isLoading: true });
    AuthService.login(obj)
      .then(data => {
        const response = data.data;
        const obj = {
          accessToken: response.accessToken,
          accessTokenExpiresAt: response.accessTokenExpiresAt,
          refreshToken: response.refreshToken,
          refreshTokenExpiresAt: response.refreshTokenExpiresAt
        };
        const userDetail = response.user;
        Storage.setTokenDetail(obj);
        Storage.setUserDetail(userDetail);
        this.props.history.push('/enroll-new-fleet');
      })
      .catch(e => {
        console.log("err", e);
        let err = e.response && e.response.data && e.response.data.error[0] ? e.response.data.error[0] : null;
        const message = err && err.message ? err.message : 'Something went wrong';

        ModalService.openAlert('Invited Fleet', message, 'error');
        this.setState({
          errResponseMessage: message,
          isLoading: false
          //  errorMessage: message, isErrorModalOpen: true 
        });
      });
  }
  sendOtp = (e, resend_otp = false) => {
    if (e) {
      e.preventDefault();
    }
    if (!this.handleValidation(true, resend_otp)) {
      return;
    }
    if (this.state.isRequestSent && resend_otp === false) {
      this.verifyOTP();
      return
    }
    const { controls } = this.state;
    const { mobile_number } = controls;
    const obj = {
      phone_number: mobile_number.value,
      "type": "fleet_reg"
    };
    this.setState({ isLoading: true });
    AuthService.inviteSendOtp(obj)
      .then(data => {
        this.setState({ isRequestSent: true, isLoading: false });
      })
      .catch(e => {
        let err = e.response && e.response.data && e.response.data.error[0] ? e.response.data.error[0] : null;
        ModalService.openAlert('', err.message, 'error');
        //        const message = err && err.message ? err.message : ERROR_MESSAGE;
        this.setState({ isLoading: false });
        // const message = e.response.data && e.response.data.message ? e.response.data.message : 'Something went wrong';
        //        ModalService.openAlert('Recover Password', message, 'error');
        // this.setState({ errorMessage: message, isErrorModalOpen: true });
      });
  }

  handleValidation = (isSubmit = false, resend_otp = false) => {

    let { controls, isFormValid } = this.state;
    let { mobile_number, otp } = controls;

    if (mobile_number.touched === true || isSubmit) {
      mobile_number = Validation.notNullValidator(mobile_number);
      mobile_number = Validation.validatePhoneNumber(mobile_number);
      mobile_number = Validation.validateLength(mobile_number, 10);
      mobile_number.valid = !(mobile_number.invalidPhone || mobile_number.nullValue || mobile_number.invalidLength);
      if (mobile_number.valid === false) {
        mobile_number.showErrorMsg = true;
      } else {
        mobile_number.showErrorMsg = false;
      }
    }
    if (otp.touched === true || isSubmit && this.state.isRequestSent && resend_otp === false) {
      otp = Validation.notNullValidator(otp);
      otp.valid = !(otp.nullValue);
      if (otp.valid === false) {
        otp.showErrorMsg = true;
      } else {
        otp.showErrorMsg = false;
      }
    }
    isFormValid = false;
    if (this.state.isRequestSent && mobile_number.valid === true &&
      otp.valid === true) {
      isFormValid = true;
    }
    if (!this.state.isRequestSent && mobile_number.valid === true || resend_otp) {
      isFormValid = true;
    }
    this.setState({ controls, isFormValid });
    return isFormValid;
  }

  resizeWindow = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  openSuccessModal = () => {
    this.setState({ isSuccessModalOpen: true });
  }

  closeSuceessModal = () => {
    this.setState({ isSuccessModalOpen: false, modalMessage: '', redirectToLoginPage: true });
  }

  openErrorModal = () => {
    this.setState({ isErrorModalOpen: true });
  }

  closeErrorModal = () => {
    this.setState({ isErrorModalOpen: false });
  }

  openLoginPage = () => {
    this.setState({ redirectToLoginPage: true });
  }

  render() {
    const { controls, redirectToLoginPage } = this.state;
    // const { username } = controls;
    return (
      <div id="forgot-password">
        {/* <Container> */}
        {this.state.isLoading && <CustomSpinner></CustomSpinner>}

        {redirectToLoginPage && <Redirect to="/login" />}
        <AlertModal
          show={this.state.isSuccessModalOpen}
          closeModal={this.closeSuceessModal}
          ///          title={title}
          msg={this.state.modalMessage}
          buttons={null}
          child={null}
        />
        {/* <ErrorModal
          closeModal={this.closeErrorModal}
          // open={this.state.isErrorModalOpen}
          title="Recover Password"
          msg={this.state.errorMessage}
          open={this.state.isErrorModalOpen}
        /> */}
        <Row>
          <Col xl="3" xs="1" md="1" className={this.state.width < 1200 ? 'display-none' : ''}>
            <img className="login-left-img" src="images/login-img.jpg" alt="" />
          </Col>
          <Col xl="1" xs="1" md="1" />
          <Col xl="7" xs="10" md="10" className="forgot-password-container">
            <Form className="width-100">
              <Row className={this.state.width < 1200 ? 'margin-top-20' : null} />
              <Row className="padding-left-13" style={{ marginBottom: '20px' }}>
                <img src="images/logo.png" width="128px" height="94px" style={{ objectFit: 'contain' }} alt="" />
              </Row>
              <Row className="welcome-text">
                Invited Fleet
              </Row>
              <Row className="sign-in-subtitle-text margin-top-5">
                {/* <div>
                    Please enter your phone number ID and a reset link will be sent to your email address.
                  </div> */}
              </Row>
              <hr />
              <Row>
                <Col xl="6" xs="12" md="12">
                  {/* <Row> */}
                  <FormGroup>
                    <Label for="mobile_number">Mobile Number</Label>
                    <Input
                      type="text"
                      name="mobile_number"
                      id="mobile_number"
                      value={controls.mobile_number.value}
                      onChange={(e) => { this.handleInputChange(e) }}
                      placeholder="Enter mobile number" />
                    {controls.mobile_number.showErrorMsg && <div className="error">*Please enter mobile number.</div>}

                  </FormGroup>
                  {/* </Row> */}
                </Col>
                {
                  this.state.isRequestSent && <Col xl="6" xs="12" md="12">
                    <FormGroup>
                      <Label for="otp">OTP</Label>
                      <Input
                        type="text"
                        name="otp"
                        id="otp"
                        value={controls.otp.value}
                        onChange={(e) => { this.handleInputChange(e) }}
                        placeholder="Enter otp" />
                      {controls.otp.showErrorMsg && <div className="error">*Please enter otp.</div>}
                    </FormGroup>
                  </Col>
                }
                {
                  this.state.isRequestSent &&
                  <Col xl="12" md="12" xs="12">
                    <span onClick={(e) => { this.sendOtp(e, true) }} className="link-blue font-weight-bold">Resend OTP</span>
                  </Col>
                }
              </Row>
              <hr />
              <Row>
                <Col xl="4" className={this.state.width < 1200 ? 'display-none' : ''} />
                <Col xl="8" xs="12" md="12" className="text-align-right" >
                  <Button className="mb-1 mr-1 btn-pill action-button forgot-password"
                    color="dark"
                    onClick={this.openLoginPage}
                  >
                    Back to login
                  </Button>{'  '}
                  <Button
                    className="mb-1 mr-1 btn-pill action-button send-recovery-link"
                    color="warning"
                    type="submit"
                    onClick={(e) => { this.sendOtp(e, false) }}
                  >
                    {this.state.isRequestSent ? 'Submit' : 'Send OTP'}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col />

          <Col xl="1" xs="1" sm="1" />

        </Row>
        {/* </Container> */}
      </div >
    );
  }
}

export default InvitedFleet;